import { api } from 'utils/api';
import { z } from 'zod';
import type { Note } from 'types/note';
import { noteSchema } from 'types/note';

const BASE = import.meta.env.VITE_DATAREPO_SERVICE_URL!;

export const alertService = {
  getNotes: () => api.get<unknown>(BASE, 'note').then(d => z.array(noteSchema).parse(d)),
  addNote: (note: Note) => api.post<void>(BASE, 'note', note),
  deleteNote: (id: string) => api.delete<void>(BASE, `note/${id}`),
};
